import { render, staticRenderFns } from "./StageFields.vue?vue&type=template&id=f9c6cffa&scoped=true"
import script from "./StageFields.vue?vue&type=script&lang=js"
export * from "./StageFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c6cffa",
  null
  
)

export default component.exports